import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const CompleteMaintenanceModal = ({ isOpen, onClose, maintenance, truck, onSuccess, language = 'pt-BR' }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    data_fim_real: '',
    custo_final: '',
    observacoes_finais: ''
  });

  const handleSubmit = async () => {
    if (!formData.data_fim_real || !formData.custo_final) {
      toast.error(language === 'pt-BR' ? 'Preencha data e custo final' : 'Fill end date and final cost');
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem('access_token');
      const API_URL = process.env.REACT_APP_BACKEND_URL;

      await axios.put(
        `${API_URL}/api/maintenance/${maintenance.id}/complete`,
        {
          data_fim_real: formData.data_fim_real,
          custo_final: parseFloat(formData.custo_final),
          observacoes_finais: formData.observacoes_finais
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success(language === 'pt-BR' ? '✅ Manutenção concluída! Caminhão disponível.' : '✅ Maintenance completed! Truck available.');
      
      setFormData({
        data_fim_real: '',
        custo_final: '',
        observacoes_finais: ''
      });
      
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erro:', error);
      toast.error(language === 'pt-BR' ? 'Erro ao concluir manutenção' : 'Error completing maintenance');
    } finally {
      setLoading(false);
    }
  };

  if (!maintenance || !truck) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>✅ {language === 'pt-BR' ? 'Concluir Manutenção' : 'Complete Maintenance'} - {truck.modelo} ({truck.placa})</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Informações da Manutenção */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-semibold mb-2">{language === 'pt-BR' ? '📋 Informações da Manutenção' : '📋 Maintenance Info'}</h4>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>
                <span className="text-gray-600">{language === 'pt-BR' ? 'Tipo:' : 'Type:'}</span>
                <p className="font-semibold capitalize">{maintenance.tipo}</p>
              </div>
              <div>
                <span className="text-gray-600">{language === 'pt-BR' ? 'Início:' : 'Started:'}</span>
                <p className="font-semibold">{maintenance.data_inicio}</p>
              </div>
              <div>
                <span className="text-gray-600">{language === 'pt-BR' ? 'Responsável:' : 'Responsible:'}</span>
                <p className="font-semibold">{maintenance.responsavel}</p>
              </div>
              <div>
                <span className="text-gray-600">{language === 'pt-BR' ? 'Custo Estimado:' : 'Estimated Cost:'}</span>
                <p className="font-semibold">${maintenance.custo?.toFixed(2)}</p>
              </div>
            </div>
            <div className="mt-2">
              <span className="text-gray-600 text-sm">{language === 'pt-BR' ? 'Descrição:' : 'Description:'}</span>
              <p className="text-sm">{maintenance.descricao}</p>
            </div>
          </div>

          {/* Dados de Conclusão */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>{language === 'pt-BR' ? 'Data de Conclusão' : 'Completion Date'} *</Label>
              <Input
                type="date"
                value={formData.data_fim_real}
                onChange={(e) => setFormData({...formData, data_fim_real: e.target.value})}
              />
            </div>
            <div>
              <Label>{language === 'pt-BR' ? 'Custo Final' : 'Final Cost'} *</Label>
              <Input
                type="number"
                step="0.01"
                value={formData.custo_final}
                onChange={(e) => setFormData({...formData, custo_final: e.target.value})}
                placeholder="0.00"
              />
            </div>
          </div>

          <div>
            <Label>{language === 'pt-BR' ? 'Observações Finais' : 'Final Notes'}</Label>
            <Textarea
              value={formData.observacoes_finais}
              onChange={(e) => setFormData({...formData, observacoes_finais: e.target.value})}
              placeholder={language === 'pt-BR' ? 'Detalhes da conclusão, peças trocadas, etc...' : 'Completion details, parts replaced, etc...'}
              rows={3}
            />
          </div>

          <div className="bg-green-50 p-3 rounded border border-green-200">
            <p className="text-sm text-green-800">
              ✅ {language === 'pt-BR' 
                ? 'Ao concluir, o caminhão voltará para DISPONÍVEL.'
                : 'Upon completion, the truck will return to AVAILABLE.'}
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {language === 'pt-BR' ? 'Cancelar' : 'Cancel'}
          </Button>
          <Button onClick={handleSubmit} disabled={loading} className="bg-green-600 hover:bg-green-700">
            {loading ? (language === 'pt-BR' ? 'Finalizando...' : 'Completing...') : (language === 'pt-BR' ? '✅ Concluir Manutenção' : '✅ Complete Maintenance')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CompleteMaintenanceModal;